<template>
  <div v-if="ref_contact">
    <div class="bg-dark p-4 library-card">
      <h3 class="font-weight-bold">{{ ref_contact.full_name }}</h3>
      <div>
        <div>
          <span>Last Update: </span>
          <b-badge :variant="isExpired ? 'warning' : 'success'" class="d-inline-block py-1" v-if="ref_contact.updated_at">{{ ref_contact.updated_at | moment('MMMM D YYYY, h:mm:ss a') }}</b-badge>
          <b-badge :variant="isExpired ? 'warning' : 'success'" class="d-inline-block py-1" v-else-if="ref_contact.created_at">{{ ref_contact.created_at | moment('MMMM D YYYY, h:mm:ss a') }}</b-badge>
        </div>
        <div class="my-2">
          <div v-if="ref_contact.type && ref_contact.type !== ''"><i class="fal fa-user pr-2"></i>{{ ref_contact.type }}</div>
          <div v-if="ref_contact.phone && ref_contact.phone !== ''"><i class="fal fa-phone pr-2"></i><a :href="'tel:'+ref_contact.phone.replace(/\D/g,'')">{{ ref_contact.phone }}</a></div>
          <div v-if="ref_contact.mobile && ref_contact.mobile !== ''"><i class="fal fa-mobile pr-2"></i><a :href="'tel:'+ref_contact.mobile.replace(/\D/g,'')">{{ ref_contact.mobile }}</a></div>
          <div v-if="ref_contact.email && ref_contact.email !== ''"><i class="fal fa-envelope pr-2"></i><a :href="'mailto:'+ref_contact.email">{{ ref_contact.email }}</a></div>
          <div v-if="ref_location && ref_location.address && ref_location.address !== ''"><i class="fal fa-building pr-2"></i>{{ ref_location.address }}</div>
        </div>
      </div>
      <div class="clearfix">
        <c-button v-if="Math.abs(customer_contact.id) !== Math.abs($store.getters.getAuthCustomerContactID)" size="sm" class="btn-sf btn-square float-right ml-2" @click="delete_modal = true"><i class="fal fa-trash"></i> Delete</c-button>
        <c-button size="sm" class="btn-sf btn-square float-right" @click="modal = true"><i class="fal fa-edit"></i> Update</c-button>
        <div v-if="!isUser" class="d-inline-block float-right mr-2">
          <b-overlay :show="inviting" spinner-small>
            <c-button size="sm" class="btn-sf btn-square" @click="invite" :disabled="!hasEmail"><i class="fal fa-envelope"></i> Invite</c-button>
          </b-overlay>
        </div>
      </div>
    </div>
    <CModal size="lg" title="Update Contact" :show.sync="modal">
      <form @submit.prevent="save">
        <contact-edit-form @cancel="modal = false" :contact="ref_contact" @change="updated_contact => (contact_state = updated_contact)" :commit="false"></contact-edit-form>
        <div v-if="isUser" class="border-left pl-2">
          <c-select
            label="Notification Preference"
            :value.sync="user_state.notification_preference"
            :options="notification_options"
            :horizontal="true"
            required
            :addLabelClasses="['font-weight-bold']"
          ></c-select>
        </div>
        <hr />
        <location-edit-form @cancel="modal = false" :location="ref_location" @change="updated_location => (location_state = updated_location)" :commit="false"></location-edit-form>
        <CRow class="mb-3">
          <CCol sm="3"></CCol>
          <CCol sm="9">
            <CInputCheckbox
              :label="'Restricted access: cannot login into portal and will not receive email notifications.'"
              placeholder=""
              :value.sync="user_state.restrictAccess"
              :horizontal="true"
              :addLabelClasses="['font-weight-bold']"
              required
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="7"></CCol>
          <CCol sm="5">
            <CButtonGroup class="w-100">
              <CButton @click="modal = false" color="default" class="btn-square">Cancel</CButton>
              <div class="d-inline-block float-right mr-2">
                <b-overlay :show="inviting" spinner-small>
                  <CButton class="btn-sf btn-square" type="submit">Save</CButton>
                </b-overlay>
              </div>
            </CButtonGroup>
          </CCol>
        </CRow>
      </form>
      <template v-slot:footer-wrapper><div></div></template>
    </CModal>
    <CModal size="lg" title="Delete Contact" :show.sync="delete_modal">
      <p>Are your sure you want to delete <b>{{ ref_contact.full_name }}?</b></p>
      <CRow>
        <CCol sm="7"></CCol>
        <CCol sm="5">
          <CButtonGroup class="w-100">
            <CButton @click="delete_modal = false" color="default" class="btn-square">Cancel</CButton>
            <CButton class="btn-sf btn-square" @click="deleteContact">Delete</CButton>
          </CButtonGroup>
        </CCol>
      </CRow>
      <template v-slot:footer-wrapper><div></div></template>
    </CModal>
  </div>
</template>

<script>
  import Contact from "../../../models/Contact"
  import ContactEditForm from "./ContactEditForm";
  import LocationEditForm from "../locations/LocationEditForm";
  import Location from "../../../models/Location";
  import ToastNotifications from "../../shared/mixins/ToastNotifications";
  import CustomerContact from "../../../models/CustomerContact";
  import User from "../../../models/User";

  export default {
  name: 'ContactCard',
  mixins: [ToastNotifications],
  components: {LocationEditForm, ContactEditForm},
  props: {
    customer_contact: {
      type: Object,
      default: null
    },
    contact: {
      type: Object,
      default: null
    },
    location: {
      type: Object,
      default: null
    },
  },
  computed: {
    isExpired() {
      return Contact.isExpired(this.ref_contact);
    },
    isUser() {
      return (this.customer_contact && this.customer_contact.user && this.customer_contact.user.id);
    },
    hasEmail() {
      return (this.ref_contact && this.ref_contact.email && this.ref_contact.email !== '');
    }
  },
  data() {
    return {
      modal: false,
      ref_contact: null,
      ref_location: null,
      ref_user: null,
      contact_state: null,
      user_state: null,
      location_state: null,
      inviting: false,
      delete_modal: false,
      notification_options: [
        {value: null, label: '- Select -'},
        {value: 'mail', label: 'Email'},
        {value: 'sms', label: 'SMS'},
        {value: 'both', label: 'Both'},
        {value: 'unsubscribe', label: 'Unsubscribe'}
      ]
    };
  },
  watch: {
    customer_contact: {
      handler: function() {
        if(this.customer_contact.contact) {
          this.ref_contact = this.customer_contact.contact;
        }
        if(this.customer_contact.location) {
          this.ref_location = this.customer_contact.location;
        }
        if(this.customer_contact.user) {
          this.ref_user = this.customer_contact.user;
          this.user_state = {notification_preference: this.ref_user.notification_preference};
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    save() {
      this.inviting = true;
      if(this.user_state) {
        this.user_state.name = this.contact_state.full_name;
        if(this.contact_state && this.contact_state.email) {
          this.user_state.email = this.contact_state.email;
        }
      }
      Promise.all([
        Contact.api().update(this.ref_contact.id, this.contact_state),
        (this.ref_location ? Location.api().update(this.ref_location.id, this.location_state) : Location.api().create(this.location_state)),
        (this.ref_user ? User.api().update(this.ref_user.id, this.user_state) : (new Promise(resolve => {return resolve()})))
      ]).then((results) => {
        let contact = results[0].entities.contacts[0];
        this.$emit('contactChange', contact);
        let location = results[1].entities.locations[0];
        this.$emit('locationChange', location);
        if(contact && location) {
          let customer_contact = this.customer_contact;
          if(!customer_contact) {
            customer_contact = CustomerContact.query().where('contact_id', contact.id).with(['contact','location','user']).first();
          }
          if(customer_contact) {
            CustomerContact.api().update(customer_contact.id, {
              contact_id: contact.id,
              location_id: location.id,
            }).then(() => {
              CustomerContact.api().export(customer_contact.id).then(() => {
                let temp = CustomerContact.query().where('id', customer_contact.id).with(['contact','location','user']).first();
                this.$emit('customerContactChange', temp);
                this.quickSuccessToast('Contact was updated', 'Thank you for keeping your contacts up to date.');
                this.modal = false;
                this.inviting = false;
              }, () => {
                this.quickSuccessToast('Contact was updated', 'Thank you for keeping your contacts up to date.');
                this.modal = false;
                this.inviting = false;
              });
            });
          } else {
            this.quickSuccessToast('Contact was updated', 'Thank you for keeping your contacts up to date.');
            this.modal = false;
            this.inviting = false;
          }
        }
      });
    },
    invite() {
      this.inviting = true;
      CustomerContact.api().invite(this.customer_contact.id).then(() => {
        let temp = CustomerContact.query().where('id', this.customer_contact.id).with(['contact','location','user']).first();
        this.$emit('customerContactChange', temp);
        this.quickSuccessToast('Contact invited', 'An invitation has been sent to this contact.');
        this.inviting = false;
      }, (err) => {
        this.quickWarningToast('Contact could not get invited', err);
        this.inviting = false;
      });
    },
    deleteContact() {
      CustomerContact.api().remove(this.customer_contact.id).then(() => {
        Contact.api().remove(this.ref_contact.id).then(() => {
          CustomerContact.delete(this.customer_contact.id);
          Contact.delete(this.ref_contact.id);
          this.delete_modal = false;
          this.quickSuccessToast('Contact was deleted', 'This contact can no longer access your records.');
          this.$emit('onDelete', this.customer_contact, this.ref_contact);
        }, (err) => {
          this.quickWarningToast('Contact could not be deleted', err);
        });
      }, (err) => {
        this.quickWarningToast('Contact could not be deleted', err);
      });
    },
    ucwords(str) {
      let lstr = str.toLowerCase();
      return lstr.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function($1){
          return $1.toUpperCase();
      });
    }
  }
}
</script>
